module.exports = "/_next/static/images/Hero@2x-141f2d307da370850d8dbed62dc56d71.png";